const SUPPORTED_LOCALES = [
  "en",
  "ja",
  "ko",
  "de",
  "es",
  "fr",
  "pl",
  "nl",
  "pt",
  "ru",
  "zh",
  "zh-tw",
] as const;

const localePrefixPattern = new RegExp(
  `^/(?:${SUPPORTED_LOCALES.join("|")})(?=/|$)`,
  "i",
);

const commercialPaths = new Set([
  "/url-to-faceless-video",
  "/script-to-faceless-video",
  "/long-form-faceless-video-generator",
  "/faceless-video-automation",
  "/faceless-youtube-video-generator",
  "/faceless-tiktok-video-generator",
  "/faceless-instagram-reels-generator",
  "/faceless-podcast-video-generator",
]);

const publicPathPatterns = [
  /^\/blog(?:\/[a-z0-9-]+)?$/,
  /^\/compare\/[a-z0-9-]+$/,
  /^\/examples\/[a-z0-9-]+$/,
  /^\/resources\/[a-z0-9-]+$/,
  /^\/templates\/[a-z0-9-]+$/,
  /^\/tools\/faceless-video-length-calculator$/,
];

const normalizePathname = (pathname: string) => {
  const withoutQuery = String(pathname || "/").split(/[?#]/, 1)[0] || "/";
  const withLeadingSlash = withoutQuery.startsWith("/")
    ? withoutQuery
    : `/${withoutQuery}`;
  return withLeadingSlash.length > 1
    ? withLeadingSlash.replace(/\/+$/, "")
    : "/";
};

export const stripAnalyticsLocale = (pathname: string) => {
  const normalized = normalizePathname(pathname);
  const stripped = normalized.replace(localePrefixPattern, "");
  return stripped || "/";
};

export const isPublicAnalyticsPath = (pathname: string) => {
  const path = stripAnalyticsLocale(pathname);

  return (
    path === "/" ||
    path === "/pricing" ||
    path === "/examples" ||
    path === "/compare" ||
    path === "/about" ||
    path === "/editorial-policy" ||
    commercialPaths.has(path) ||
    publicPathPatterns.some((pattern) => pattern.test(path))
  );
};

export const getSanitizedAnalyticsPath = (pathname: string) =>
  isPublicAnalyticsPath(pathname) ? normalizePathname(pathname) : null;

export const getAnalyticsPageGroup = (pathname: string) => {
  const path = stripAnalyticsLocale(pathname);

  if (path === "/") return "homepage";
  if (path === "/pricing") return "pricing";
  if (commercialPaths.has(path)) return "commercial";
  if (path.startsWith("/blog")) return "blog";
  if (path === "/compare" || path.startsWith("/compare/")) return "comparison";
  if (path === "/examples" || path.startsWith("/examples/")) return "example";
  if (path.startsWith("/resources/")) return "resource";
  if (path.startsWith("/templates/")) return "template";
  if (path.startsWith("/tools/")) return "tool";
  if (path === "/about" || path === "/editorial-policy") return "trust";
  return null;
};
